module.exports = __webpack_public_path__ + "static/media/trash.45465add.svg";